<template>
	<div class="pic-txt-row" :class="reverse ? 'reverse' : ''">
		<div class="pic">
			<img :src="data.img" :alt="data.title">
		</div>
		<div class="txt">
			<h1>{{data.title}}</h1>
			<p>{{data.desc}}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "pictxtRow",
	props: {
		data: [Object],
		reverse: {
			type: [Boolean],
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
//pic-txt-row
.pic-txt-row + .pic-txt-row {
	margin-top: 80px;
}
.pic-txt-row {
	display: flex;
	.pic {
		flex: 0 0 470px;
		border-radius: 10px;
		overflow: hidden;
		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.txt {
		flex: 1;
		margin-left: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		span {
			@extend .semibold-16px;
			opacity: 0.5;
		}
		h1 {
			font-family: 'Arial';
			font-style: normal;
			font-weight: 550;
			font-size: 24px;
			line-height: 32px;
			margin-bottom: 16px;
		}
		p {
			@extend .regular-14px;
		}
	}
}
.pic-txt-row.reverse {
	flex-direction: row-reverse;
	.txt {
		margin-left: 0;
		margin-right: 40px;
	}
}
@media only screen and (max-width: 767px) {
	.pic-txt-row {
		display: block;
	}
	.pic-txt-row .txt {
		margin-left: 0;
		margin-top: 10px;
	}
	.pic-txt-row.reverse .txt {
		margin-right: 0;
		margin-top: 10px;
	}
	.pic-txt-row + .pic-txt-row {
		margin-top: 40px;
	}
	.pic-txt-row .txt span {
		font-size: 14px;
		margin-bottom: 10px;
	}
	.pic-txt-row .txt h1 {
		margin-bottom: 10px;
	}
}
</style>
